const rootPath = '/videos'

const videoMaterials = {
  manMeditating: `${rootPath}/man-meditating.mp4`,
  manMeditatingPoster: `${rootPath}/man-meditating-poster.png`,
}

export default videoMaterials